import dayjs from '../../../../utils/dayjs';

export const generateDailyActivity = () => {
  const dailyActivity = [];
  const daysQuantity = 35;
  for (let i = 0; i < daysQuantity; i++) {
    const kills = Math.floor(Math.random() * 21);
    const matches = kills ? Math.ceil((kills / 3) + Math.floor(Math.random() * kills / 2)) : 0;
    const avgPlacement = kills ? Math.ceil(kills / (matches * 2.5)) + Math.floor(Math.random() * (kills / matches)) : 0;
    dailyActivity.push({
      date: dayjs().subtract(daysQuantity - i, 'days').unix(),
      kills,
      matches,
      avgPlacement,
      avgPerformance: kills ? (kills / matches) * (100 / avgPlacement) : 0,
    });
  }
  return dailyActivity;
};

export const fortniteStatsMock = {
  general: {
    playerName: 'Seadawg',
    matches: 2490,
    wins: 20,
    winRatio: 20,
    avgKills: 18,
    avgPlacement: 2,
    avgPerformance: 247,
    points: 2000,
    queues: {
      solo: {
        kills: 2382,
        matches: 696,
        playersOutlived: 35184,
        placements: 37309,
        score: 114317,
        wins: 13,
        top10s: 111,
        deaths: 683,
        avgKills: 3,
        avgPlacement: 54,
      },
      duo: {
        kills: 1170,
        matches: 362,
        playersOutlived: 20065,
        placements: 21875,
        score: 79962,
        wins: 36,
        top10s: 109,
        deaths: 326,
        avgKills: 3,
        avgPlacement: 60,
      },
      squad: {
        kills: 1278,
        matches: 324,
        playersOutlived: 18782,
        placements: 20526,
        score: 88257,
        wins: 58,
        top10s: 288,
        deaths: 266,
        avgKills: 4,
        avgPlacement: 63,
      },
    },
    others: {
      avgKills: 13,
      avgPlacement: 10,
    },
  },
  activity: {
    dailyActivity: generateDailyActivity(),
    weekActivity: {
      'hoursPlayed': 40,
      'change': 79.89,
    },
    monthActivity: {
      'hoursPlayed': 142,
      'change': 140,
    },
    rankProgression: [
      {
        date: '1599264000',
        score: 0,
      }, {
        date: '1599868800',
        score: 200,
      }, {
        date: '1600473600',
        score: 344,
      }, {
        date: '1601078400',
        score: 100,
      }, {
        date: '1601683200',
        score: 605,
      }, {
        date: '1602288000',
        score: 800,
      }, {
        date: '1602892800',
        score: 720,
      },

      // NOTE Hardcoded more points for testing scroll in graph
      {
        date: '1603492800',
        score: 803,
      },
      {
        date: '1604092800',
        score: 780,
      },
      {
        date: '1604692800',
        score: 790,
      },
      {
        date: '1605292800',
        score: 580,
      },
      {
        date: '1605892800',
        score: 1024,
      },
      {
        date: '1606492800',
        score: 790,
      },
      {
        date: '1607092800',
        score: 810,
      },
      {
        date: '1607692800',
        score: 874,
      },
      {
        date: '1608292800',
        score: 720,
      },
      {
        date: '1608892800',
        score: 823,
      },
      {
        date: '1609492800',
        score: 828,
      },
      {
        date: '1610092800',
        score: 914,
      },
      {
        date: '1610692800',
        score: 720,
      },
      {
        date: '1611292800',
        score: 614,
      },
      {
        date: '1611892800',
        score: 870,
      },
      {
        date: '1612492800',
        score: 720,
      },
    ],
  },
  rank: {
    overrall: 10,
    hub: 10,
    state: 14,
    country: 33,
    gameRank: 'Diamond 3',
    selectedHub: '4',
  },
};
export const fortniteStatsMock2 = {
  general: {
    playerName: 'hot wheels',
    matches: 2000,
    wins: 80,
    winRatio: 10,
    avgKills: 12,
    avgPlacement: 8,
    avgPerformance: 150,
    queues: {
      solo: {
        kills: 1800,
        matches: 800,
        playersOutlived: 431,
        placements: 5435,
        score: 104317,
        wins: 16,
        top10s: 123,
        deaths: 675,
        avgKills: 2,
        avgPlacement: 76,
      },
      duo: {
        kills: 1070,
        matches: 262,
        playersOutlived: 21065,
        placements: 22875,
        score: 76962,
        wins: 46,
        top10s: 119,
        deaths: 346,
        avgKills: 2,
        avgPlacement: 60,
      },
      squad: {
        kills: 1078,
        matches: 304,
        playersOutlived: 18082,
        placements: 20026,
        score: 80257,
        wins: 50,
        top10s: 208,
        deaths: 206,
        avgKills: 1,
        avgPlacement: 43,
      },
    },
    others: {
      avgKills: 12,
      avgPlacement: 22,
    },
  },
  activity: {
    dailyActivity: generateDailyActivity(),
    weekActivity: {
      'hoursPlayed': 40,
      'change': 79.89,
    },
    monthActivity: {
      'hoursPlayed': 142,
      'change': 140,
    },
    rankProgression: [
      {
        date: '1599264000',
        score: 0,
      }, {
        date: '1599868800',
        score: 50,
      }, {
        date: '1600473600',
        score: 70,
      }, {
        date: '1601078400',
        score: 120,
      }, {
        date: '1601683200',
        score: 400,
      }, {
        date: '1602288000',
        score: 450,
      }, {
        date: '1602892800',
        score: 390,
      },
    ],
  },
  rank: {
    overrall: 12,
    hub: 22,
    state: 22,
    country: 22,
    gameRank: 'Gold 4',
    selectedHub: '4',
  },
};

export class FortnitePlayerData {
  constructor(data = {}) {
    this.general = data.general || false;
    this.queues = data.queues || false;
    this.activity = data.activity || false;
    this.rank = data.rank || false;
    this.rankProgression = data.rankProgression || false;
  }
}
